import utils from '@/util'
import {
  defaultHeadingText, isBlockExist, hasTag, generateBlockId,
  generateBlockHash,
} from './common'

const titleLayoutThumbnail = require('@/assets/images/content-slide-layouts/layout_title.svg')

const defaultHeadingStyle = {
  width: '1200px',
  height: '90px',
  transform: 'translate(30px, 270px)',
}
const headingContent = (headingText) => {
  return {
    value: `
    <p style="text-align: center;" data-mce-style="text-align: center;">
      <span style="font-size: 52px;" data-mce-style="font-size: 52px;">
        <strong>
          ${headingText}
        </strong>
      </span>
    </p>
    `,
  }
}

const defaultHeadingContent = headingContent(defaultHeadingText)

function layoutBuilder(slideId, currentCanvasBlocks) {
  if (!slideId) {
    slideId = (Math.random() + 1).toString(36).substring(6)
  }
  const newCanvasBlocks = { ...currentCanvasBlocks }
  // Add default block to make layout if not exists
  if (!isBlockExist(currentCanvasBlocks, hasTag('heading'))) {
    newCanvasBlocks[`slide-${slideId}-heading`] = {
      type: 'RichText',
      tag: 'heading',
      content: defaultHeadingContent,
      style: defaultHeadingStyle,
      h: generateBlockHash(),
    }
  }

  if (currentCanvasBlocks) {
    Object.keys(currentCanvasBlocks).forEach((blockId) => {
      const block = currentCanvasBlocks[blockId]
      if (block.tag === 'heading') {
        const newBlock = {
          ...block,
          id: generateBlockId(slideId),
          style: defaultHeadingStyle,
          hidden: false,
          content: headingContent(utils.extractContent(block.content.value || defaultHeadingText, true)),
          h: generateBlockHash(),
        }
        newCanvasBlocks[newBlock.id] = newBlock
        delete newCanvasBlocks[blockId]
      } else {
        newCanvasBlocks[blockId] = {
          ...block,
          hidden: true,
        }
      }
    })
  }

  return newCanvasBlocks
}

const HeadingLayout = {
  type: 'heading',
  name: 'Title',
  layoutThumbnailImage: titleLayoutThumbnail,
  build: layoutBuilder,
}

export default HeadingLayout
